package org.vreo.devicehub.features.core.presentation.components.largeDropdownMenu

import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.LocalContentColor
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.CompositionLocalProvider
import androidx.compose.ui.Modifier
import androidx.compose.ui.tooling.preview.Preview
import androidx.compose.ui.unit.dp

/**
 * Large dropdown menu item. Displays text and it's selected state.
 *
 * @param text text to display
 * @param isSelected is item selected
 * @param onClick action handler for item click
 */
@Composable
fun LargeDropdownMenuItem(
    text: String,
    isSelected: Boolean,
    onClick: () -> Unit,
) {
    val contentColor = when {
        isSelected -> MaterialTheme.colorScheme.primary
        else -> MaterialTheme.colorScheme.onSurface
    }

    CompositionLocalProvider(LocalContentColor provides contentColor) {
        Box(
            modifier = Modifier
                .clickable { onClick() }
                .fillMaxWidth()
                .padding(16.dp)
        ) {
            Text(
                text = text,
                style = MaterialTheme.typography.titleSmall
            )
        }
    }
}

@Preview
@Composable
fun LargeDropdownMenuItemPreview() {
    MaterialTheme {
        LargeDropdownMenuItem(
            text = "Item 1",
            isSelected = true,
            onClick = {}
        )
    }
}